import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from './PopupBox.js';



export default class OK extends React.Component {
  render() {



    //handle the click on one of the buttons
    const handleClick = (e) => {

      this.props.setResult(true, this)

      



    };


   

    return (




            <header className="App-header justify-content-center scorecard">
                    
                    
                    <h3 className="text-danger">{this.props.question}</h3>

                    
                    <br></br>

                    <div className="d-flex justify-content-center">


                    <ButtonToolbar>
                        <Button onClick={handleClick} className="mr-3" variant={this.props.color0} size="lg">{this.props.text0}</Button>  
                    </ButtonToolbar>


                    </div>

  
            </header>





    );
  }
}
